import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import TimeManager from './Utils/TimeManager'

export default class SceneCore
{        
    
    sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }

    constructor()
    {
        if (this.sizes.height * 0.8 > this.sizes.width) this.isMobile = true 
        else this.isMobile = false

        // scene variables
        this.STside = 1.0
        this.GRIDsize = 13
        this.GRIDposition = 0.23
        this.GRIDsquare = this.STside / this.GRIDsize

        this.canvas = document.querySelector('canvas.webgl')

        this.scene = new THREE.Scene()

        // renderer
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            logarithmicDepthBuffer: false,
            antialias: false
        })
        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        this.renderer.toneMapping = THREE.LinearToneMapping;
        this.renderer.setClearColor( "black", 1);
        this.renderer.toneMappingExposure = 1.4

        // resize canvas
        window.addEventListener('resize', () =>
        {   
            // Update sizes
            this.sizes.width = window.innerWidth
            this.sizes.height = window.innerHeight

            // Update camera
            this.camera.left = this.sizes.width / - 1200 / this.mobileFactor
            this.camera.right = this.sizes.width / 1200 / this.mobileFactor
            this.camera.top = this.sizes.height / 1250 / this.mobileFactor
            this.camera.bottom = this.sizes.height / - 1250 / this.mobileFactor
            this.camera.updateProjectionMatrix()

            // Update renderer
            this.renderer.setSize(this.sizes.width, this.sizes.height)
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        })

        // main camera
        //this.camera = new THREE.PerspectiveCamera(15, this.sizes.width / this.sizes.height, 3, 15)
        this.mobileFactor = 1
        if (this.isMobile) this.mobileFactor = 0.5
        this.camera = new THREE.OrthographicCamera( this.sizes.width / - 1200 / this.mobileFactor, this.sizes.width / 1200 / this.mobileFactor, this.sizes.height / 1250 / this.mobileFactor, this.sizes.height / - 1250 / this.mobileFactor, -2, 20 );
        this.camera.position.x = -2.8 * this.mobileFactor
        this.camera.position.y = 3.3 * this.mobileFactor
        this.camera.position.z = 3.2 * this.mobileFactor

        this.add(this.camera)

        // Camera Controls and Zoom
        let mobileZoomFactor = 0
        if (this.isMobile) mobileZoomFactor = 0.3
        this.controls = new OrbitControls(this.camera, this.canvas)
        this.controls.enableDamping = true
        this.controls.dampingFactor = 0.15
        this.controls.enablePan = false
        this.controls.target = new THREE.Vector3(0, 0.1, 0)
        this.controls.minPolarAngle = 0.7
        this.controls.maxPolarAngle = 1.1
        this.controls.maxZoom = 1.5 + mobileZoomFactor*3
        this.controls.minZoom = 1.0 - mobileZoomFactor
        this.controls.saveState()

        // Update Manager
        this.time = new TimeManager()

        // Update Listener
        this.time.on('tick', () =>
        {
            this.update()
        })
    }

    update() {
        this.controls.update()
        this.renderer.render(this.scene, this.camera)
    }

    add(object) {
        this.scene.add(object)
    }

    remove(object) {
        this.scene.remove(object)
    }
}